import { AfterViewInit, ChangeDetectorRef, Component, ErrorHandler, OnDestroy, OnInit, ViewChild, ChangeDetectionStrategy, signal } from '@angular/core'
import { FieldTree, form } from '@angular/forms/signals'
import { ActivatedRoute } from '@angular/router'

import { DateAdapter } from '@angular/material/core'
import { MatDatepicker } from '@angular/material/datepicker'
import { MatInput } from '@angular/material/input'

import { AsiakkaatDataSourceStateService, LukemanTyyppiVanha } from './asiakkaat.datasource.service'

import { AsiakasService, LokalisoituAlvIlmoitusjakso, LokalisoituYritysmuoto } from '../../_angular/service/asiakas/asiakas.service'

import { AlvIlmoitusjakso, EiYhtiomuotoaYhtiomuoto } from '../../_jaettu-lemonator/model/asiakas'

import { arvonMuutokset, asetaArvo } from 'app/_jaettu-angular/_lomakkeet/arvon-muutokset'
import { LemonTranslationService } from 'app/_jaettu-angular/service/lemon-translation.service'

import { Observable, Subject } from 'rxjs'
import { debounceTime, map, takeUntil } from 'rxjs/operators'

import { Platform } from '@angular/cdk/platform'
import { LocalMonth } from '@lemon/core/model/common'
import { LemonKuukausiDateAdapter } from 'app/_jaettu-angular/_material/LemonKuukausiDateAdapter'

import { Yritysmuoto } from '@lemon/core-firebase/model/kayttaja'
import { DateService } from '@lemon/core/service/date.service'
import { VersionTarkistusPalvelu } from 'app/_angular/service/version-tarkistus.palvelu'

export interface KuukausiJaValmiusaste extends LocalMonth {
  valmiusaste: number
  valmiusasteMuotoiltu: string
}

// interface TyontekoInfo {
//   asiakkaita: number,
//   asiakkaitaJoillaHinta: number,
//   nykyinenKuukausilaskutus: Big
//   keskimaarainenhinta: Big,
//   keskimaarainenPaivatavoite: Big
//   tehtyTanaan: Big
//   progressio: Big
//   seuraavaErapaiva: Date
//   paiviaSeuraavaanErapaivaan: number
//   progressioonLisattava: Big
//   dynaaminenSumma: Big
//   palluroidenSumma: Big
//   huutomerkkienSumma: Big
// }

interface AsiakkaidenHakuLomake {
  nimi: string
  yhtiomuoto: Yritysmuoto | EiYhtiomuotoaYhtiomuoto | null
  alvjakso: AlvIlmoitusjakso | null
  vuosikkalku: Date | null
  vuosikkloppu: Date | null
  minuutitvaitehot: LukemanTyyppiVanha | null
  vaintoimiavaativat: boolean
}

@Component({
  templateUrl: './asiakkaat.component-old.html',
  styleUrls: ['./asiakkaat.component.css'],
  providers: [
    // `MomentDateAdapter` can be automatically provided by importing `MomentDateModule` in your
    // application's root module. We provide it at the component level here, due to limitations of
    // our example generation script.
    { provide: DateAdapter, useClass: LemonKuukausiDateAdapter, deps: [ErrorHandler, DateService, Platform, LemonTranslationService] },
  ],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class AsiakkaatComponentOld implements OnInit, OnDestroy, AfterViewInit {
  @ViewChild('hakuInput', { read: MatInput, static: true }) hakuInput: MatInput

  private ngUnsubscribe: Subject<void> = new Subject<void>()

  // tyontekoInfoObservable: Observable<TyontekoInfo>
  naytaTehoObservable: Observable<boolean>
  lomake: FieldTree<AsiakkaidenHakuLomake>

  yritysmuodot: LokalisoituYritysmuoto[]
  alvjaksot: LokalisoituAlvIlmoitusjakso[]
  minMonthStart = new Date(2015, 0, 1)
  maxMonthStart = new Date(2099, 11, 1)
  minMonthEnd = new Date(2015, 0, 1)
  maxMonthEnd = new Date(2099, 11, 1)

  constructor(
    private _changeDetectorRef: ChangeDetectorRef,
    private _route: ActivatedRoute,
    private _asiakkaatDataSourceStateService: AsiakkaatDataSourceStateService,
    private _asiakasService: AsiakasService,
    private _dateService: DateService,
    private _versionTarkistusPalvelu: VersionTarkistusPalvelu,
  ) {
    this.alvjaksot = this._asiakasService.alvIlmoitusjaksot
    this.yritysmuodot = this._asiakasService.yritysmuodotJaEiTiedossa

    this._route.url
      .pipe(
        map(urlSegments => {
          for (const o of urlSegments) {
            if (o.path === 'holvi') {
              return true
            }
          }
          return false
        }),
        takeUntil(this.ngUnsubscribe),
      )
      .subscribe(showHolviAsiakkaat => {
        if (this._asiakkaatDataSourceStateService.naytaHolviPoolAsiakkaatSubject.value !== showHolviAsiakkaat) {
          // console.log('Set näytä holvi pool', showHolviAsiakkaat)
          this._asiakkaatDataSourceStateService.naytaHolviPoolAsiakkaatSubject.next(showHolviAsiakkaat)
        }
      })

    const aloitusaikavali = this._asiakkaatDataSourceStateService.getCurrentTimespan()
    const alkaa = this._dateService.localDateToDate({ year: aloitusaikavali.start.year, month: aloitusaikavali.start.month, day: 12 })
    this.minMonthEnd = alkaa
    const loppuu = this._dateService.localDateToDate({ year: aloitusaikavali.end.year, month: aloitusaikavali.end.month, day: 12 })
    this.maxMonthStart = loppuu

    this.lomake = form(
      signal<AsiakkaidenHakuLomake>({
        nimi: this._asiakkaatDataSourceStateService.vapaaTekstihakuObservable.value ?? '',
        yhtiomuoto: this._asiakkaatDataSourceStateService.yhtiomuotoObservable.value ?? null,
        alvjakso: this._asiakkaatDataSourceStateService.alvjaksoObservable.value ?? null,
        vuosikkalku: alkaa,
        vuosikkloppu: loppuu,
        minuutitvaitehot: this._asiakkaatDataSourceStateService.lukemanTyyppiVanhaObservable.value ?? null,
        vaintoimiavaativat: this._asiakkaatDataSourceStateService.naytaVainToimiaVaativatAsiakkaatObservable.value ?? null,
      }),
    )
    arvonMuutokset(this.lomake.nimi)
      .pipe(debounceTime(300), takeUntil(this.ngUnsubscribe))
      .subscribe(value => {
        if (value) {
          const val = value.trim().toLowerCase()
          this._asiakkaatDataSourceStateService.vapaaTekstihakuOldListObservable.next(val)
        } else {
          this._asiakkaatDataSourceStateService.vapaaTekstihakuOldListObservable.next(null)
        }
      })
    arvonMuutokset(this.lomake.yhtiomuoto)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(value => {
        // console.log('Asetettu', value)
        this._asiakkaatDataSourceStateService.yhtiomuotoObservable.next(value)
      })
    arvonMuutokset(this.lomake.alvjakso)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(value => {
        // console.log('Asetettu', value)
        this._asiakkaatDataSourceStateService.alvjaksoObservable.next(value)
      })
    arvonMuutokset(this.lomake.vuosikkalku)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(value => {
        if (this.lomake.vuosikkalku().valid() && value) {
          this.minMonthEnd = value
          this._asiakkaatDataSourceStateService.setStartMonth({ month: value.getMonth() + 1, year: value.getFullYear() })
        }
      })
    arvonMuutokset(this.lomake.vuosikkloppu)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(value => {
        if (this.lomake.vuosikkloppu().valid() && value) {
          // console.log('asetettu vuosikkloppu 2', value)
          this.maxMonthStart = value
          this._asiakkaatDataSourceStateService.setEndMonth({ month: value.getMonth() + 1, year: value.getFullYear() })
        }
      })
    arvonMuutokset(this.lomake.minuutitvaitehot)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(arvo => {
        this._asiakkaatDataSourceStateService.lukemanTyyppiVanhaObservable.next(arvo)
      })
    arvonMuutokset(this.lomake.vaintoimiavaativat)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(value => {
        this._asiakkaatDataSourceStateService.naytaVainToimiaVaativatAsiakkaatObservable.next(!!value)
      })

    this._asiakkaatDataSourceStateService.valittuAikavaliObservable.pipe(takeUntil(this.ngUnsubscribe)).subscribe(aikavali => {
      if (aikavali) {
        if (aikavali.start) {
          const nykyinen = this.lomake.vuosikkalku().value()
          const month = (nykyinen?.getMonth() ?? -2) + 1
          const year = nykyinen?.getFullYear() ?? -1
          if (month !== aikavali.start.month || year !== aikavali.start.year) {
            const date = this._dateService.localDateToDate({ year: aikavali.start.year, month: aikavali.start.month, day: 12 })
            asetaArvo(this.lomake.vuosikkalku, date, { ilmoita: false })
          }
        }
        if (aikavali.end) {
          const nykyinen = this.lomake.vuosikkloppu().value()
          const month = (nykyinen?.getMonth() ?? -2) + 1
          const year = nykyinen?.getFullYear() ?? -1
          if (month !== aikavali.end.month || year !== aikavali.end.year) {
            const date = this._dateService.localDateToDate({ year: aikavali.end.year, month: aikavali.end.month, day: 12 })
            asetaArvo(this.lomake.vuosikkloppu, date, { ilmoita: false })
          }
        }
      }
    })
    this._asiakasService.asetaNykyinenAsiakas(null)
  }

  chosenMonthHandlerAlku(normalizedMonth: Date, datepicker: MatDatepicker<Date>) {
    asetaArvo(this.lomake.vuosikkalku, normalizedMonth)
    datepicker.close()
  }

  chosenMonthHandlerLoppu(normalizedMonth: Date, datepicker: MatDatepicker<Date>) {
    asetaArvo(this.lomake.vuosikkloppu, normalizedMonth)
    datepicker.close()
  }

  ngOnDestroy() {
    this.ngUnsubscribe.next()
    this.ngUnsubscribe.complete()
  }

  ngAfterViewInit() {
    setTimeout(() => {
      this._asiakasService.asetaNykyinenAsiakas(null)
      this.hakuInput.focus()
      this._changeDetectorRef.markForCheck()
    }, 10)
  }

  ngOnInit() {
    this._versionTarkistusPalvelu.sovelluksenVersioObservable.pipe(takeUntil(this.ngUnsubscribe)).subscribe(versio => {
      this._versionTarkistusPalvelu.tarkistaVersio(versio)
    })

    // this.tyontekoInfoObservable = this._asiakasDataSourceService.kaikkiKirjanpitajanAsiakkaat.pipe(
    //   map(asiakkaat => {

    //     const paluuarvo: TyontekoInfo = {
    //       asiakkaita: 0,
    //       asiakkaitaJoillaHinta: 0,
    //       keskimaarainenhinta: new Big(0),
    //       nykyinenKuukausilaskutus: new Big(0),
    //       keskimaarainenPaivatavoite: new Big(0),
    //       tehtyTanaan: new Big(0),
    //       progressio: new Big(0),
    //       seuraavaErapaiva: null,
    //       paiviaSeuraavaanErapaivaan: null,
    //       progressioonLisattava: new Big(0),
    //       dynaaminenSumma: new Big(0),
    //       palluroidenSumma: new Big(0),
    //       huutomerkkienSumma: new Big(0)
    //     }

    //     for (const asiakas of asiakkaat) {
    //       paluuarvo.asiakkaita++
    //       if (asiakas.voimassaolevaHinta && asiakas.voimassaolevaHinta.hinta) {
    //         paluuarvo.nykyinenKuukausilaskutus = paluuarvo.nykyinenKuukausilaskutus.plus(asiakas.voimassaolevaHinta.hinta)
    //         paluuarvo.asiakkaitaJoillaHinta++
    //       }
    //       if (asiakas.paivanSaldo) {
    //         paluuarvo.tehtyTanaan = paluuarvo.tehtyTanaan.plus(asiakas.paivanSaldo)
    //       }
    //       if (asiakas.palluroidenSumma) {
    //         paluuarvo.palluroidenSumma = paluuarvo.palluroidenSumma.plus(asiakas.palluroidenSumma)
    //         paluuarvo.progressio = paluuarvo.progressio.minus(asiakas.palluroidenSumma)
    //       }
    //       if (asiakas.huutomerkkienSumma) {
    //         paluuarvo.huutomerkkienSumma = paluuarvo.huutomerkkienSumma.plus(asiakas.huutomerkkienSumma)
    //         paluuarvo.progressio = paluuarvo.progressio.minus(asiakas.huutomerkkienSumma)
    //       }
    //       if (asiakas.dynaaminenHinta) {
    //         paluuarvo.dynaaminenSumma = paluuarvo.dynaaminenSumma.plus(asiakas.dynaaminenHinta)
    //       }
    //       if (asiakas.vahennysProgressiosta) {
    //         paluuarvo.progressioonLisattava = paluuarvo.progressioonLisattava.plus(asiakas.vahennysProgressiosta)
    //       }
    //     }
    //     if (paluuarvo.asiakkaitaJoillaHinta > 0) {
    //       paluuarvo.keskimaarainenhinta = paluuarvo.nykyinenKuukausilaskutus.div(paluuarvo.asiakkaitaJoillaHinta)
    //       paluuarvo.keskimaarainenPaivatavoite = paluuarvo.nykyinenKuukausilaskutus.div(20)
    //     }

    //     paluuarvo.dynaaminenSumma = new Big(0).minus(paluuarvo.keskimaarainenPaivatavoite).plus(paluuarvo.dynaaminenSumma)

    //     const nyt = this._dateService.dateToLocalDate(this._aikakone.annanNykyinenPaivamaara())

    //     paluuarvo.seuraavaErapaiva = this._dateService.localDateToDate(nyt.day > 12 ? this._dateService.lisaaKuukausiaPaikallinen(nyt, 1) : nyt)
    //     paluuarvo.seuraavaErapaiva.setDate(12)
    //     paluuarvo.paiviaSeuraavaanErapaivaan = this._dateService.laskeArkipaivatPaivienValilla(this._aikakone.annanNykyinenPaivamaara(), paluuarvo.seuraavaErapaiva)
    //     paluuarvo.progressio = paluuarvo.progressio.plus(paluuarvo.progressioonLisattava)

    //     // console.log('Lasketaan tyontekoinfoa.')

    //     return paluuarvo

    //   }),
    //   lemonShare()
    // )
  }
}
